import SOSEOUL from '../assets/SO_SEOUL.png';
import RESTORE from '../assets/Restore.png';

export const BUSINESS_PARTNERS = [
  {
    name: "So Seoul Korean Café",
    category: "Hospitality / F&B",
    description: "Authentic Korean café experience, brought to life with NEPHRC's restaurant planning and brand consultancy.",
    accent: "from-rose-200/40 to-amber-100/40",
    image: SOSEOUL,
  },
  {
    name: "RESTORE Convenience Store (24×7)",
    category: "Retail",
    description: "Modern 24×7 convenience retail — site, store and supply chain consulting by NEPHRC.",
    accent: "from-emerald-200/40 to-cyan-100/40",
    image: RESTORE,
  },
  {
    name: "NCC - Naga Coffee Culture",
    description: "Specialty coffee experience, crafted with NEPHRC's cafe planning, concept development, and brand consultancy.",
    accent: "from-amber-200/40 to-orange-100/40",
  },
  {
    name: "Mondo Legal Firm, Delhi",
    category: "Corporate / Office",
    description: "Professional workplace planning, modern office design and corporate consultancy by NEPHRC.",
    accent: "from-blue-200/40 to-slate-100/40",
  },
];

export const SPORTS_PARTNERS = [
  {
    name: "Max Sport Academy",
    category: "Sports",
    description: "Sports infrastructure planning and youth development partnership.",
    accent: "from-blue-200/40 to-indigo-100/40",
  },
  {
    name: "United Bharat FC",
    category: "Sports",
    description: "Football club partnership — stadium consultancy and training facility design.",
    accent: "from-amber-200/40 to-orange-100/40",
  },
];

export const PARTNER_MARQUEE = [
  "So Seoul Korean Café",
  "RESTORE 24×7",
  "NCC - Naga Coffee Culture",
  "Mondo Legal Firm",
  "Max Sport Academy",
  "United Bharat FC",
  "State PWD",
  "Smart City SPV",
  "PSU Infrastructure",
  "Tourism Board",
];
